'use strict';

exports.__esModule = true;
exports.page = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

var _bookAppointmentSection = require('../actions/book-appointment-section');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _specialistProfile = require('../transformers/specialist-profile');

var _aggregateReview = require('../transformers/aggregate-review');

var _doctifyUtils = require('doctify-utils');

var _bookAppointmentSection2 = require('./book-appointment-section');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// type specialistData = {
// 	uri_id: String,
// 	doctify_id: String,
// 	attributes: {
// 		profile_featured_image: String
// 		about: String
// 	},
// 	name: String,
// 	insurers: []
// }

var INITIAL_STATE = {
	hasReceivedAuthedReviews: false
};

// Here for the sake of neatness. When all this redux is refactored this should be kept (and accessed) in book-appointment-section actions/reducers.

var HOURS_AFTER_CURRENT_TIME = 3;

var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var page = exports.page = function page(state, action) {
	var _Object$assign2;

	switch (action.type) {
		case _pageActions.REMOVE_PATIENT_AVAILABILITY:
			{
				var newAvailabilities = state.availabilities.map(function (availabilitiesItems) {
					return (0, _assign2.default)({}, availabilitiesItems, { availabilities: availabilitiesItems.availabilities.filter(function (item) {
							return item.availability_id !== action.actionData.availability_id;
						}) });
				});
				return (0, _assign2.default)({}, state, { availabilities: newAvailabilities });
			}
		case _pageActions.LOAD_SPECIALIST_PROFILE + '_RECEIVED':
			{
				var specialist = (0, _specialistProfile.transformSpecialist)(action.response.specialist, action.response.practices, action.actionData.specialties, action.actionData.hospitalList, action.actionData.network);
				return (0, _assign2.default)({}, state, specialist, {
					hospitalList: action.actionData.hospitalList,
					isHospitalListModalOpen: !action.actionData.network, // do not open modal for network pages, always true if not network
					reviews: specialist.showReviews ? state.reviews : []
				});
			}
		case _pageActions.LOAD_SPECIALIST_PROFILE + '_FAILED':
			return (0, _extends3.default)({}, state, { specialistLoadError: true });
		case _pageActions.CLEAR_SPECIALIST:
			return (0, _assign2.default)({}, state, INITIAL_STATE);
		case _pageActions.LOAD_SPECIALIST_REVIEWS + '_RECEIVED':
			var firstLoad = action.actionData ? action.actionData.firstLoad : true;
			var reviews = firstLoad ? (0, _specialistProfile.transformProfileReviews)(action.response.reviews) : [].concat(state.reviews, (0, _specialistProfile.transformProfileReviews)(action.response.reviews));
			var showReviews = state.showReviews === true || typeof state.showReviews === "undefined";
			return (0, _assign2.default)({}, state, {
				reviews: showReviews ? reviews : [],
				averageRating: action.response.aggregate_review
			});
		case _pageActions.LOAD_SPECIALIST_AGGREGATE_REVIEW + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				aggregateReview: (0, _aggregateReview.transformAggregateReview)(action.response)
			});
		case _pageActions.LOAD_SPECIALIST_PEER_RECOMMENDATIONS + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				peerRecommendations: (0, _specialistProfile.transformProfilePeerRecommendations)(action.response)
			});
		case _pageActions.LOAD_SPECIALIST_AVAILABILITIES + '_REQUESTED':
			{
				return (0, _assign2.default)({}, state, { isLoadingAvailabilities: true });
			}
		case _pageActions.LOAD_SPECIALIST_AVAILABILITIES + '_RECEIVED':
			{
				var availabilities = state.availabilities && state.availabilities.slice() || [];
				action.response.forEach(function (dayOfAvailabilities) {
					var day = [];

					// remove old availability with same start_date
					var oldAvailabilitiesIndex = availabilities.findIndex(function (item) {
						return item.start_date === dayOfAvailabilities.start_date;
					});
					if (oldAvailabilitiesIndex !== -1) {
						availabilities.splice(oldAvailabilitiesIndex, 1);
					}

					dayOfAvailabilities.availabilities.forEach(function (availability) {
						var slot = availability.availability_details && availability.availability_details.timestamp_range && JSON.parse(availability.availability_details.timestamp_range);
						if ((availability.practice.id === state.selectedPractice.id || state.selectedPractice.id === null) && state.practices.find(function (p) {
							return p.id === availability.practice.id;
						}) && availability && slot && slot.length && _moment2.default.utc(slot[0]).isAfter(_moment2.default.utc().add(HOURS_AFTER_CURRENT_TIME, 'h'))) {
							day.push(availability);
						}
					});
					availabilities.push({ availabilities: day, start_date: dayOfAvailabilities.start_date });
				});
				return (0, _assign2.default)({}, state, {
					availabilities: action.response && action.response.length ? availabilities : [],
					isLoadingAvailabilities: false
				});
			}
		case _pageActions.LOAD_SPECIALIST_AVAILABILITIES + '_FAILED':
			{
				return (0, _assign2.default)({}, state, {
					availabilities: [],
					isLoadingAvailabilities: false
				});
			}
		case _pageActions.LOAD_SPECIALIST_BLOG_POSTS + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				articles: (0, _specialistProfile.transformBlogPosts)(action.response)
			});
		case _pageActions.LOAD_PATIENT_ATTRIBUTES + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				patient: action.response.patient
			});
		case _pageActions.TOGGLE_LIKE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				reviews: state.reviews.map(function (review) {
					if (review.id === action.actionData) {
						return (0, _extends3.default)({}, review, {
							liked: !review.liked,
							likes: action.response.likes || action.response.review.likes
						});
					} else {
						return review;
					}
				})
			});
		case _pageActions.TOGGLE_SECTION:
			return (0, _assign2.default)({}, state, (_Object$assign2 = {}, _Object$assign2[action.sectionName + 'SectionExpanded'] = !action.toggleValue, _Object$assign2));
		case _pageActions.UDPATE_CALENDAR_START_DATE:
			return (0, _assign2.default)({}, state, { calendarStartDate: action.startDate });
		case _pageActions.TOGGLE_CALENDAR_VIEW:
			return (0, _assign2.default)({}, state, { activeView: action.view });
		case _pageActions.LOADE_URI:
			return (0, _assign2.default)({}, state, { loadedUri: action.uri });
		case _pageActions.INIT_LOADED:
			return (0, _assign2.default)({}, state, { isInitLoaded: true });
		case LOCATION_CHANGE:
			return typeof window === 'undefined' || state.loadedUri && action.payload.pathname && action.payload.pathname.includes(state.loadedUri) ? state : { loadedUri: '', isInitLoaded: true, hasReceivedAuthedReviews: false };
		case _bookAppointmentSection.PRACTICE_SELECTED:
			return (0, _assign2.default)({}, state, { selectedPractice: action.practice, availabilities: [] });
		case _pageActions.SET_NEAREST_AVAILABILITY:
			return (0, _assign2.default)({}, state, { nearestAvailability: action.date });
		case _pageActions.SET_LATEST_AVAILABILITY_FOUND:
			return (0, _assign2.default)({}, state, { latestAvailabilityFound: action.date });
		case _pageActions.SET_HAS_RECEIVED_AUTHED_REVIEWS:
			return (0, _assign2.default)({}, state, { hasReceivedAuthedReviews: true });
		case _pageActions.TOGGLE_HOSPITAL_LIST_MODAL_STATE:
			return (0, _assign2.default)({}, state, { isHospitalListModalOpen: action.isHospitalListModalOpen });
		case _pageActions.CHOOSE_HOSPITAL_LIST:
			return (0, _assign2.default)({}, state, {
				practices: [_bookAppointmentSection2.allPracticesObject].concat((0, _specialistProfile.transformPractices)(state.originalPractices, state.videoConsultation, action.hospitalList), [state.network]),
				hospitalList: action.hospitalList
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/specialist-page/lib/reducers/page-reducers.js